import type { IRootScopeService, ITimeoutService } from "angular";
import { module } from "angular";
import type IMasonryService from "./IMasonryService";

export default class MasonryService implements IMasonryService {
    public static $inject: string[] = ["$rootScope", "$timeout"];

    constructor(private readonly $rootScope: IRootScopeService, private readonly $timeout: ITimeoutService) {}

    public reload(delay?: number): void {
        const d: number = delay || 0;

        // eslint-disable-next-line
        this.$timeout(() => {
            this.$rootScope.$broadcast("masonry.reload");
        }, d);
    }
}

module("mmManagePortal").service("irMasonryService", MasonryService);
